import { render, staticRenderFns } from "./CarbonClapOption.vue?vue&type=template&id=67c17d5b&scoped=true&"
import script from "./CarbonClapOption.vue?vue&type=script&lang=js&"
export * from "./CarbonClapOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c17d5b",
  null
  
)

export default component.exports